const getOffsetTop = element => {
  let offsetTop = 0
  while(element) {
    offsetTop += element.offsetTop
    element = element.offsetParent
  }
  return offsetTop
}

export function initAnchorLinks() {
  const linkEls = document.querySelectorAll('.js-anchor-link')

  linkEls.forEach(linkEl => linkEl.addEventListener('click', e => {
    e.preventDefault()

    const destinationTop = getOffsetTop(document.querySelector(linkEl.getAttribute('href')))
    const headerHeight = document.querySelector('.js-header').offsetHeight

    window.scrollTo({
      behavior: 'smooth',
      top: destinationTop - headerHeight,
    })
  }))
}
